import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { z } from "zod";
import { localeRoute } from "./locale";

const searchParamsSchema = z.object({
  start_name: z.string(),
  end_name: z.string(),
  start_address: z.string(),
  end_address: z.string(),
  pickup_datetime: z.string().optional(),
  mode: z.enum(["one_way", "round_trip"]),
  num_passengers: z.number().or(z.string()),
  currency: z.string().optional(),
  return_pickup_datetime: z.string().optional(),
  start_id: z.string().optional(),
  end_id: z.string().optional(),
  ref: z.string().optional(),
  utm_campaign: z.string().optional(),
  utm_source: z.string().optional(),
  branch: z.string().optional(),
  flight_datetime: z.string().optional(),
  return_flight_datetime: z.string().optional(),
  airline: z.string().optional(),
  flight_number: z.number().or(z.string()).optional(),
  airline2: z.string().optional(),
  flight_number2: z.number().or(z.string()).optional(),
  dial_code: z.string().optional(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  email: z.string().optional(),
  phone_number: z.number().or(z.string()).optional(),
  coupon_code: z.number().or(z.string()).optional(),
  partner_tracking_id: z.number().or(z.string()).optional(),
  gid: z.number().or(z.string()).optional(),
  guid: z.number().or(z.string()).optional(),
  customer_special_instructions: z.string().optional(),
  hourly_booking_duration: z.number().optional(),
});

export type SearchParams = z.infer<typeof searchParamsSchema>;

export const searchRoute = createRoute({
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    const result = searchParamsSchema.safeParse(search);

    if (result.success) {
      if (!result.data.pickup_datetime && !result.data.flight_datetime) {
        throw new Error("pickup_datetime or flight_datetime is required");
      }
      return result.data;
    }

    console.error("Invalid search params:", result.error?.errors);
    throw new Error("Invalid query parameters");
  },
  getParentRoute: () => localeRoute,
  path: "/search",
  component: lazyRouteComponent(() => import("../pages/search-results-router")),
});
